import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Input } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FileTextOutlined } from '@ant-design/icons';
import ROUTES from '../../../constants/routes';

const StandardButton = styled(Button)`
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  font-size: 14px !important;
  padding: 0 15px !important;
  border-radius: 6px !important;
`;

const StandardInput = styled(Input)`
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  font-size: 14px !important;
  border-radius: 6px !important;
`;

const SearchFilterBar = ({
  searchText,
  onSearchChange,
  onFilterClick,
  onAddUser,
  activeTab
}) => {
  const navigate = useNavigate();

  return (
    <div 
      className="filters-animate-in"
      style={{
        marginBottom: '16px',
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        flexWrap: 'wrap'
      }}
    >
      {/* Search Input - Takes up available space */}
      <div style={{ flex: '1 1 300px', minWidth: '300px' }}>
        <StandardInput
          placeholder="Search by name, email, or phone..."
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: '100%' }}
          allowClear
        />
      </div>
      
      {/* Filter Button */}
      <StandardButton
        icon={<FontAwesomeIcon icon={faFilter} />}
        onClick={onFilterClick}
      >
        Filter
      </StandardButton>
      
      {/* Add User Button */}
      <StandardButton
        type="primary"
        icon={<FontAwesomeIcon icon={faPlus} />}
        onClick={onAddUser}
      >
        {activeTab === 'volunteers' ? 'Add Volunteer' : 'Add User'}
      </StandardButton>

      {/* View Registrations Button - only on volunteers tab */}
      {activeTab === 'volunteers' && (
        <StandardButton
          icon={<FileTextOutlined />}
          onClick={() => navigate(ROUTES.ADMIN_VOLUNTEER_REGISTRATIONS)}
        >
          View Registrations
        </StandardButton>
      )}
    </div>
  );
};

export default SearchFilterBar;
